import { infiniteQueryOptions, queryOptions } from '@tanstack/react-query'

import { fetchTenantRoles, fetchUser, fetchUsers } from '#admin/features/platform/users/api.ts'

/**
 * The user search, one page at a time.
 *
 * An infinite query rather than page numbers, because the server pages by cursor: "page 40" is
 * not a question keyset paging can answer cheaply, and nobody browsing logins wants it.
 */
export const usersQuery = (q: string) =>
  infiniteQueryOptions({
    queryKey: ['platform', 'users', q],
    queryFn: ({ pageParam, signal }) => fetchUsers({ q, cursor: pageParam }, signal),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (last) => last.nextCursor ?? undefined,
    staleTime: 10_000,
  })

export const userQuery = (userId: string) =>
  queryOptions({
    queryKey: ['platform', 'user', userId],
    queryFn: ({ signal }) => fetchUser(userId, signal),
    staleTime: 5_000,
  })

export const tenantRolesQuery = (tenantId: string) =>
  queryOptions({
    queryKey: ['platform', 'tenant-roles', tenantId],
    queryFn: ({ signal }) => fetchTenantRoles(tenantId, signal),
    staleTime: 60_000,
  })
